import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetResources } from '../../../hooks/resources';

import MainLayout from '../../layouts/Main';
import { SVGIcon } from '../../wrappers/SVGIcon';
import { ResourcesListTable } from '../../sub_components/tables/ResourcesList';

import { Icons } from '../../../data/Assets';

const ResourcesListPage = () => {
    const navigate = useNavigate();

    const { data: resources, isLoading } = useGetResources();

    const onGoToCreateResource = () => {
        navigate('/resources/create');
    };

    return (
        <MainLayout>
            <div className="immersion__page_view">
                <h2 className="immersion__color__dark mb_20">Resources</h2>

                <div className="immersion__lists__top_section mb_30">
                    <div className="display_flex display_flex_end mr_10">
                        <button className="immersion__btn immersion__btn__primary" onClick={onGoToCreateResource}>
                            <SVGIcon src={Icons.Plus} />
                            <span>Add&nbsp;Resource</span>
                        </button>
                    </div>
                </div>

                <div className="immersion__split_list_view">
                    <ResourcesListTable
                        resources={resources ?? []}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </MainLayout>
    );
};

export default ResourcesListPage;